// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.b8568720a',
  revision: 'b8568720a',
  branch: 'develop',
  date: 'Fri, 18 Sep 2026 16:34:37 GMT'
};